import Submitter from "./Submitter";

/** @typedef {import("./Tag").default} Tag */
/** @typedef {{ topic: string, id: string, _ts: number, region: string, title: string, text: { id: string, content: string }[], tagIds: number[], audienceIds: number[], files: string[], fileUrls: string[], submitter: { firstName: string, lastName: string, street: string, zip: string, city: string } }} PageTemplateObj */

export default class PageTemplate {

    /**
     * A template for a displayable screen.
     * @param {string} topic The topic this page belongs to
     * @param {string} title The full heading of the page
     * @param {[string, string][]} text The html contents of the page
     * @param {number []} tagIds The tag ids of this page
     * @param {number []} audienceIds The audience tag ids of this page
     * @param {string []} files The files that were uploaded with this page
     * @param {string []} fileUrls The download actual links to the files
     * @param {string} region The region of the project this page is about
     * @param {Submitter} submitter The submitter of the page
     * @param {string} id The id of this page in the cosmosDB
     * @param {number} _ts The unix timestamp when this page was last edited
     */
    constructor( topic, title, text, tagIds = [], audienceIds = [], files = [], fileUrls = [], region = undefined, submitter = undefined, id = undefined, _ts = Date.now()/1000 ) {
        this.topic = topic;
        this.title = title;
        this.text = new Map(text);
        this.tagIds = tagIds;
        this.audienceIds = audienceIds;
        this.files = files;
        this.fileUrls = fileUrls;
        this.region = region;
        this.submitter = submitter;

        this.id = id;
        this._ts = _ts;

        /** @type {Tag []} */
        this.tags = [];

        /** @type {Tag []} */
        this.audiences = [];
    }

    /**
     * @param {Tag []} tags 
     */
    setTags( tags ) {
        this.tags = tags;
        return this;
    }

    /**
     * @param {Tag []} audiences 
     */
    setAudiences( audiences ) {
        this.audiences = audiences;
        return this;
    }

    /**
     * @param {PageTemplateObj} obj 
     */
    static fromObject( obj ) {
        return new PageTemplate( obj.topic, obj.title, obj.text, obj.tagIds, obj.audienceIds, obj.files, obj.fileUrls, obj.region, obj.submitter instanceof Submitter ? obj.submitter : Submitter.fromObject(obj.submitter), obj.id, obj._ts );
    }

}